import React, { useState } from 'react';
import styles from './Pocetna.module.css';
import * as constants from '../util/constants';
import PocetnaOglasnaPloca from './PocetnaOglasnaPloca';

const Pocetna = () => {
  const [ gotOglasData, setGotOglasData ] = useState(false);

  return (
    <div className={styles.pocetnaContent}>
      {constants.OGLASNE_PLOCE.map(oglasnaPloca => {
        return <PocetnaOglasnaPloca
          setGotOglasData={setGotOglasData}
          naslov={oglasnaPloca.naziv}
          id={oglasnaPloca.id}
          key={oglasnaPloca.id} />
      })}
      {gotOglasData?null:(
        <div className={styles.emptyListContainer}>Nema aktivnih oglasa.</div>
      )}
    </div>
  );
}

export default Pocetna;